<!--If you do not know how WellnessTaskTemplate corresponds to WellnessTask, then please get clarification
prior to changing this page. -->

<br>
  <div>
    <span class="headerText">Wellness Task Templates</span>
    <div style="float:right">
      <div>
        <div class="headerToggleDiv">
          <label for="showInactive">Show Inactive Wellness Task Templates</label>
          <p-checkbox binary="true" name="showInactive" [(ngModel)]="getInactives" (ngModelChange)="getTasks()">
          </p-checkbox>
        </div>
        <p-button type="button" class="addNewButton" (click)="addNew();">Add New</p-button>
      </div>
    </div>
  </div>
<br/>
  <p-table showGridlines stripedRows responsiveLayout="stack" [columns]="cols" [value]="tasks" [paginator]="true" [rows]="30">
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [style.width]="col.width">
            {{col.header}}
            @if (col.header != '') {
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
              </p-sortIcon>
            }
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-task let-columns="columns" let-rowIndex="rowIndex">
      <tr>
        <td><span class="p-column-title">{{columns[0].header}}</span>{{task.name}}</td>
        <td><span class="p-column-title">{{columns[1].header}}</span>{{task.description}}</td>
        <td><span class="p-column-title">{{columns[2].header}}</span>{{task.growingDegreeDay }}</td>
        <td><span class="p-column-title">{{columns[3].header}}</span>{{task.price | currency: 'USD' : 'symbol'}}</td>
        <td><span class="p-column-title">{{columns[4].header}}</span>{{task.active == true ? 'Active' : 'Not Active'}}
      </td>
      <td>
        <p-button type="button" icon="pi pi-pencil" (click)="editTask(task)"
          severity="info" >
        </p-button>
        @if (showDeleteForTask(task)) {
          <p-button type="button" icon="pi pi-trash" (click)="deleteTask(task)" severity="danger">
          </p-button>
        }
      </td>
    </tr>
  </ng-template>
</p-table>